<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="oui?.visiteDetail"
	
	[label]="step5.visiteDetail"
	[type]="'text'"
	[rule]="'minSize_1|maxSize_300|required'"
	[errorMessage]="{'required' : 'ctr_9710'}"
	[name]="getUid() + '_SepAtt_visiteDetail'"
>
</app-form-input>
